export var TeamMemberRole;
(function (TeamMemberRole) {
    TeamMemberRole[TeamMemberRole["LEADER"] = 1] = "LEADER";
    TeamMemberRole[TeamMemberRole["MEMBER"] = 2] = "MEMBER";
})(TeamMemberRole || (TeamMemberRole = {}));
/**
 * 心愿内容枚举
 */
export var WISH_CODE_ENUM;
(function (WISH_CODE_ENUM) {
    /** 看一场璀璨烟花秀 */
    WISH_CODE_ENUM[WISH_CODE_ENUM["FIREWORKS"] = 1] = "FIREWORKS";
    /** 泡一次惬意温泉 */
    WISH_CODE_ENUM[WISH_CODE_ENUM["HOT_SPRING"] = 2] = "HOT_SPRING";
    /** 听一场震撼演唱会 */
    WISH_CODE_ENUM[WISH_CODE_ENUM["CONCERT"] = 3] = "CONCERT";
    /** 举杯庆祝新一年 */
    WISH_CODE_ENUM[WISH_CODE_ENUM["TOAST"] = 4] = "TOAST";
    /** 求一张新年好运签 */
    WISH_CODE_ENUM[WISH_CODE_ENUM["FORTUNE"] = 5] = "FORTUNE";
    /** 倒计时欢呼迎来新一年 */
    WISH_CODE_ENUM[WISH_CODE_ENUM["COUNTDOWN"] = 6] = "COUNTDOWN";
    /** 滑雪跨越新一年 */
    WISH_CODE_ENUM[WISH_CODE_ENUM["SKIING"] = 7] = "SKIING";
    /** 看新年第一次日出 */
    WISH_CODE_ENUM[WISH_CODE_ENUM["SUNRISE"] = 8] = "SUNRISE";
    /** 跟家人一起欢聚 */
    WISH_CODE_ENUM[WISH_CODE_ENUM["FAMILY_REUNION"] = 9] = "FAMILY_REUNION";
    /** 吃一顿超满足美食 */
    WISH_CODE_ENUM[WISH_CODE_ENUM["DELICIOUS_FOOD"] = 10] = "DELICIOUS_FOOD";
})(WISH_CODE_ENUM || (WISH_CODE_ENUM = {}));
export var TeamStatus;
(function (TeamStatus) {
    TeamStatus[TeamStatus["ACTIVE"] = 1] = "ACTIVE";
    TeamStatus[TeamStatus["PAUSE"] = 2] = "PAUSE";
    TeamStatus[TeamStatus["END"] = 3] = "END";
    TeamStatus[TeamStatus["DISMISS"] = 4] = "DISMISS";
})(TeamStatus || (TeamStatus = {}));
export var PeriodStatus;
(function (PeriodStatus) {
    PeriodStatus[PeriodStatus["NOT_STARTED"] = 0] = "NOT_STARTED";
    PeriodStatus[PeriodStatus["IN_PROGRESS"] = 1] = "IN_PROGRESS";
    PeriodStatus[PeriodStatus["END_WAITING_SETTLEMENT"] = 2] = "END_WAITING_SETTLEMENT";
    PeriodStatus[PeriodStatus["END_SETTLED"] = 3] = "END_SETTLED";
    PeriodStatus[PeriodStatus["END_ABNORMAL"] = 4] = "END_ABNORMAL";
})(PeriodStatus || (PeriodStatus = {}));
export var TeamOperateType;
(function (TeamOperateType) {
    TeamOperateType[TeamOperateType["CREATE"] = 1] = "CREATE";
    TeamOperateType[TeamOperateType["JOIN"] = 2] = "JOIN";
})(TeamOperateType || (TeamOperateType = {}));
export var TeamRankingStatus;
(function (TeamRankingStatus) {
    /* 未开始 */
    TeamRankingStatus[TeamRankingStatus["NOT_STARTED"] = -1] = "NOT_STARTED";
    /* 进行中 */
    TeamRankingStatus[TeamRankingStatus["IN_PROGRESS"] = 0] = "IN_PROGRESS";
    /** 公示期 */
    TeamRankingStatus[TeamRankingStatus["PUBLICITY"] = 1] = "PUBLICITY";
    /* 已下线 */
    TeamRankingStatus[TeamRankingStatus["OFFLINE"] = 2] = "OFFLINE";
    /* 中奖 */
    TeamRankingStatus[TeamRankingStatus["WON_REWARD"] = 3] = "WON_REWARD";
    /* 计算中 */
    TeamRankingStatus[TeamRankingStatus["CALCULATING"] = 4] = "CALCULATING";
})(TeamRankingStatus || (TeamRankingStatus = {}));
export var RewardType;
(function (RewardType) {
    RewardType[RewardType["FREE_CARD"] = 8] = "FREE_CARD";
    // 免单卡
    RewardType[RewardType["POINTS"] = 10] = "POINTS"; // 积分
})(RewardType || (RewardType = {}));
var SCENE_TYPE;
(function (SCENE_TYPE) {
    SCENE_TYPE[SCENE_TYPE["ORDER"] = 1] = "ORDER";
    SCENE_TYPE[SCENE_TYPE["BROWSE"] = 2] = "BROWSE";
    SCENE_TYPE[SCENE_TYPE["CALL"] = 3] = "CALL";
})(SCENE_TYPE || (SCENE_TYPE = {}));
export var InviteStatus;
(function (InviteStatus) {
    InviteStatus[InviteStatus["SUCCESS"] = 0] = "SUCCESS";
    InviteStatus[InviteStatus["FAILED"] = 1] = "FAILED";
})(InviteStatus || (InviteStatus = {}));
/**
 * 业务维度邀请状态
 *
 * - 对于邀请发积分场景，代表的是「发积分」是否成功
 */
export var InviteRewardAssignStatus;
(function (InviteRewardAssignStatus) {
    InviteRewardAssignStatus[InviteRewardAssignStatus["SUCCESS"] = 0] = "SUCCESS";
    InviteRewardAssignStatus[InviteRewardAssignStatus["FAILED"] = 1] = "FAILED";
})(InviteRewardAssignStatus || (InviteRewardAssignStatus = {}));
export var AssistStatus;
(function (AssistStatus) {
    AssistStatus[AssistStatus["NOT_ASSIST"] = 0] = "NOT_ASSIST";
    AssistStatus[AssistStatus["SUCCESS"] = 1] = "SUCCESS";
    AssistStatus[AssistStatus["FAILED"] = 2] = "FAILED";
})(AssistStatus || (AssistStatus = {}));
export var TaskType;
(function (TaskType) {
    TaskType[TaskType["VIEW"] = 4] = "VIEW";
    TaskType[TaskType["ORDER"] = 1044] = "ORDER";
})(TaskType || (TaskType = {}));
